import React, { useState, useEffect, useRef } from 'react';
import NotificationTable from './NotificationTable';
import NotificationUserTable from './NotificationUserTable';
import { getNotificationmodels, clearNotificationmodels } from '../../flux/actions/notificationmodelActions';
import { Container, Row, Col, Button, 
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane } from 'reactstrap';

import { connect } from 'react-redux';
import { NotificationContainer, INotificationReduxProps, ITarget } from '../../types/interfaces';
import NotificationAdd from './NotificationAdd';
import LoadingPage from '../../pages/loading';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faUsers, faSearch, faBell, faList, faHistory } from '@fortawesome/free-solid-svg-icons'
import { PRIVILEGE } from '../../types/privileges';
import { constants } from '../../types/constants';
import Loading from '../Loading';

const NotificationContainerComponent = ({
  getNotificationmodels,
  clearNotificationmodels,
  notification_model,
  user,
  auth
 }: NotificationContainer) => {
  const { notification_models, loading } = notification_model;
  const {users, loading: loadingU} = user
  const [tableData, setTableData] = useState<any[]>([]);
  const [tableDataU, setTableDataU] = useState<any[]>([]);
  const MAIN_TAB_NAME = "MAIN"
  const HISTORY_TAB_NAME = "HISTORY"
  const [activeTab, setActiveTab] = useState(MAIN_TAB_NAME);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    getNotificationmodels();
  }, [getNotificationmodels, auth?.user]);

  useEffect(() => {
    return () => {
      clearNotificationmodels();
    }
  }, []);

  useEffect(() => {
    setTableData(notification_models.filter(e => !e.private || (auth?.user?.id && e.createdById === auth.user.id)).sort((a, b) => {
      if(a.id == null) return 1
      if(b.id == null) return -1
      return b.id - a.id
    }));
  }, [notification_models, auth?.user?.id]);

  useEffect(() =>{
    setTableDataU(users.map(e => ({
      user: e,
      ...(Object.fromEntries(constants.NOTIFICATION_TYPES.map(t => [`type_${t.code}`, tableData.filter(n => n.type === t.code && n.notifications?.find(s => s.userId === e.id)).length])))
    })))
  }, [tableData])

  return (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col xs="12" md="8"><h2 className="title"><FontAwesomeIcon icon={faBell} />&nbsp;&nbsp;Gestion des Notifications</h2></Col>
          <Col xs="12" md="4" className="modalAddBtnCol">
            <Button
              className="btn btn-success linesConfirmationBtn"
              onClick={() => setModal(true)}
              ><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajouter une notification</Button>
          </Col>
        </Row>
      </Container>
      <Container>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={`fullFlexCenter${activeTab === MAIN_TAB_NAME ? " active" : ""}`}
              onClick={() => setActiveTab(MAIN_TAB_NAME)} >
              <FontAwesomeIcon icon={faList} />&nbsp;Notifications
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={`fullFlexCenter${activeTab === HISTORY_TAB_NAME ? " active" : ""}`}
              onClick={() => setActiveTab(HISTORY_TAB_NAME)} >
              <FontAwesomeIcon icon={faHistory} />&nbsp;Historique par utilisateur
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={MAIN_TAB_NAME}>
            {loading ? <Loading /> : <NotificationTable linesData={tableData} setTableData={setTableData} />}
          </TabPane>
          <TabPane tabId={HISTORY_TAB_NAME}>
            {loading ? <Loading /> : <NotificationUserTable linesData={tableDataU} setTableData={setTableDataU} notification_models={tableData} />}
          </TabPane>
        </TabContent>
      </Container>
      <NotificationAdd modal={modal} setModal={setModal} />
    </>
  );
};

const mapStateToProps = (state: INotificationReduxProps) => ({
  notification_model: state.notification_model,
  user: state.user,
  auth: state.auth
});

export default connect(mapStateToProps, { getNotificationmodels, clearNotificationmodels })(NotificationContainerComponent);
